import { AnalyticsService } from 'app/components/analytics/analytics.service';
import { SharedService } from './../../services/shared.service';
import { AfterViewInit, Component, HostListener, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SessionService } from 'app/components/common/session/session.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ModalLoginComponent } from 'app/components/modal-login/modal-login.component';
import { LoginService } from 'app/components/login/login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DetailsService } from 'app/components/details/details.service';
import { FiltersService } from 'app/components/filters/filters.service';
import {LanguagesService} from "../languages/languages.service";
import {UtilsService} from "../utils/utils.service";
import { CatalogueService } from '../catalogue/catalogue.service';
import { RolesService } from 'app/components/roles/roles.service';
import { CONSTANTS, Tabs, Views } from 'environments/common';
import { CatalogueUserService } from 'app/components/catalogueUser/catalogue-user.service';
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { ENV } from 'environments/environment';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';
  logoUrl: string = '';
  availableLanguages: Array<any> = ["en","es","ca"];
  showLoggedMenu: boolean = false;
  selectedView: string;
  roles: object = CONSTANTS.ROLES;

  eventName: string|null = '';
  catalogueId: string|null = '';
  
  defaults = {
    tabs: Tabs.ONLY_EXHIBITORS,
    views: Views.LIST
  };

  // Variables
  windows: boolean = false;
  isMobileOpen: boolean = false;
  isLanguagesOpen: boolean = false;
  favoriteEmptyColor: string = '#000';  // Example color
  public eventData:any = null;
  
  faCaretRight = faCaretRight;
  faCaretDown = faCaretDown;

  private readonly destroy$ = new Subject();
  private lastProcessedSapCode: string;


  constructor(private sessionService: SessionService, public translateService: TranslateService, private modalService: NgbModal,
    public loginService: LoginService, private router: Router, private detailsService: DetailsService, private filtersService: FiltersService,
    private languageService:LanguagesService, public catalogueService: CatalogueService,
    public utilsService:UtilsService, public rolesService: RolesService, private catalogueUserService: CatalogueUserService, private activatedRoute: ActivatedRoute,
    private sharedService:SharedService, private analyticsService: AnalyticsService) {
    this.eventName = this.activatedRoute.snapshot.paramMap.get('event') || null;
    this.catalogueId = this.activatedRoute.snapshot.paramMap.get('catalogueId') || null;
    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
  }

  login(){
    const modalRef = this.modalService.open(ModalLoginComponent);
  }

  logoutBtn() {

    let logoutIn = {
      catalogueId: this.catalogueService.getProperty('id') || this.catalogueId,
      catalogueUserId: this.catalogueUserService.getProperty('id')
    };

    this.logout(logoutIn);

  }

  setLang(lang){
    this.translateService.use(lang);
    // Actualizar solo el parámetro de idioma en la URL
    this.sharedService.updateLanguageInUrl();
  };

  logout(logoutIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.loginService.logout(logoutIn)
      .subscribe((data: object) => {
        this.logoutOk(data);
      },
        error => {
          this.logoutError(error);
        });

  }

  logoutOk(data) {

    this.loader.count--;

    this.loginService.removeSessionVariables();
    this.toggleShowLoggedMenu();

    /** Redirect to home page after logout */
    this.loginService.redirectToHome();
    this.reloadPage();

  }

  reloadPage() {
    window.location.reload();
  }

  logoutError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  toggleShowLoggedMenu() {
    this.showLoggedMenu = !this.showLoggedMenu;
  }

  goTo(page) {

    if (!page) {
      return;
    }

    let catalogueId = this.catalogueService.getProperty('id') || this.catalogueId;
    let url = '';
    let queryParams = {};

    switch(page) {
      case 'my-exhibitor':
        url = this.catalogueService.getProperty('eventName') + '/exhibitor-backoffice/util-info';
        break;
      case 'home':
        url = this.catalogueService.getProperty('eventName') + '/' + page;
        queryParams = { filter: 'ONLY_EXHIBITORS'};
        break;
      default:
        url = this.catalogueService.getProperty('eventName') + '/' + catalogueId + '/' + page;
        break;
    }

    this.router.navigate([url], { queryParams: queryParams });

  }

  goToBackOfficeUrl() {
    window.open(ENV.APP.FRONTEND_URL, '_blank');
  }

  getDetailsJson(getDetailsJsonIn, local = false) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.detailsService.getDetailsJson(getDetailsJsonIn, local)
      .subscribe((data: object) => {
        this.getDetailsJsonOk(data, local);
      },
        error => {
          this.getDetailsJsonError(error);
        });

  }

  getDetailsJsonOk(data, local) {

    this.loader.count--;
    this.detailsService.setDetailsJson(data, local);

    if (this.detailsService.detailsJsonLoaded && this.detailsService.localDetailsJsonLoaded) {
      this.setDefaults();
    }

  }

  getDetailsJsonError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
    this.detailsService.setIsUpdateDetails(true);

    if(!this.selectedView)
      this.filtersService.setSelectedView(this.defaults.views.toLocaleLowerCase());

  }

  setDefaults() {
    let defaultView = this.detailsService.getPropertyByKey('home.view.default') || '';

    if(!this.selectedView){
      this.filtersService.setSelectedView(defaultView.toLowerCase());
    }

    this.detailsService.getPropertyByKey('anonymous.mail.sending', true);
  }

  getAvailableLang(){

    let catalogueId = this.catalogueService.getProperty('id') || this.catalogueId;

    this.languageService.getCatalogueLanguages(catalogueId).subscribe((languages) => {
          const languagesArray: string[] = Object.values(languages);
          let appLanguages = languagesArray.map(value => {
            return this.utilsService.getLanguageShortISO(value); // Obtener los primeros dos caracteres
          });
          this.availableLanguages = appLanguages;
          this.sessionService.set('availableLanguages', this.availableLanguages, false);
          this.sessionService.set('availableLanguagesLong', languages, false);

          this.getCustomCatalogueTranslations();

        },
        error => {
          console.error("[getCatalogueLanguages]ERROR", error);
        });
  }

  getLocale(lang:string){
    switch(lang){
      case 'en':
        return 'en_GB';
        break;
      case 'ca':
        return 'ca_ES';
        break;
      default: return 'es_ES';
    }
  }

  getCustomCatalogueTranslations(){
    
    for (let i = 0; i < this.availableLanguages.length; i++) {
        if (this.availableLanguages[i]) {
            let dataIn = {
                sapCode: this.catalogueService.getProperty('sapCode'),
                lang: this.getLocale(this.availableLanguages[i])
            };
            this.languageService.getRemoteCustomTranslationsJson(dataIn).subscribe(
                (data) => {
                  if (!this.utilsService.isEmptyObject(data))
                    this.sessionService.set('customTranslations_' + dataIn.sapCode + '_' + this.availableLanguages[i], data);
                },
                (error) => {
                    console.error("[getCustomCatalogueTranslations]ERROR", error);
                }
            );
        } else {
            console.warn("[getCustomCatalogueTranslations]WARNING: this.availableLanguages[" + i + "] is undefined");
        }
    }
  }

  getCatalogueProperties(getCataloguePropertiesIn) {
    this.catalogueService.getCatalogueProperties(getCataloguePropertiesIn.eventId).subscribe(data => {
      this.getCataloguePropertiesOk(data);
    }, err => {
      this.getCataloguePropertiesError(err);
    });
  }

  getCataloguePropertiesOk(data) {
    this.catalogueService.setDataProperties(data);
  }

  getCataloguePropertiesError(error) {
    console.log('error');
    console.log(error);
  }

  fetchCatalogueDataFallback() {
    let eventCode = this.eventName;

    if (!eventCode) {
      return;
    }

    this.catalogueService.ensureDataLoaded(eventCode)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: object) => {
        // Data is set by CatalogueService.ensureDataLoaded(); getData() subscription will react to it.
      },
        error => {
          console.error("[fetchCatalogueDataFallback]ERROR", error);
        });
  }

  ngOnInit() {

    this.catalogueService.getData()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        if (!data || !data['sapCode']) {
          this.fetchCatalogueDataFallback();
          return;
        }

        if (data['sapCode'] === this.lastProcessedSapCode) {
          return;
        }
        this.lastProcessedSapCode = data['sapCode'];

        // AM-7804: las propiedades del catálogo se piden aquí, ya con el id del evento
        // resuelto. Antes se pedían en ngOnInit leyendo el id de forma síncrona, cuando
        // el evento todavía no se había cargado: en la primera carga el id era null y
        // las pantallas se quedaban sin propiedades (no se veía nada).
        this.getCatalogueProperties({ eventId: data['id'] || this.catalogueId });

        let getDetailsJsonIn = {
          sapCode: this.catalogueService.getProperty('sapCode')
        };

        this.getDetailsJson(getDetailsJsonIn, true);

        this.getDetailsJson(getDetailsJsonIn);

        this.detailsService.setIsUpdateDetails(true);

        this.getAvailableLang();
      });

    this.filtersService.getSelectedView()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.selectedView = data;
      });

    // AM-7804: getCatalogueProperties se llama desde la suscripción a getData(), cuando
    // ya se conoce el id del evento. Aquí el id todavía no está disponible.

    if(window.innerWidth > 768 ) {
      this.windows = false;//TODO no usar el this.windows subcribirse al evento y usar esa varible
    } else {
      this.windows = true;
    }

    this.sharedService.setIsMobile(this.windows);

    
    if (this.eventData.catalogueTrackingId) {
      this.analyticsService.insertGtmScripts(this.eventData.catalogueTrackingId);
      this.analyticsService.initAnalytics(this.eventData.catalogueTrackingId);
    }

  }

  @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
        let width = (event.target as Window).innerWidth;
        if(width > 768 ) {
          this.windows = false;//TODO no usar el this.windows subcribirse al evento y usar esa varible
        } else {
          this.windows = true;
        }
        this.sharedService.setIsMobile(this.windows);
    }

    openMenuMobile(){
      this.isMobileOpen = !this.isMobileOpen;
    }

    openHeaderMenu(): void {
      this.isMobileOpen = !this.isMobileOpen;
    }

    onDelete(): void {
      // Handle delete favorite logic here
    }

    openLanguages(): void {
      this.isLanguagesOpen = !this.isLanguagesOpen;
    }

    getBackgroundColor(): string {
      return this.eventData['headerColor'];
    }

    ngOnDestroy(): void {
      this.destroy$.next(true);
      this.destroy$.complete();
    }

}
